import request from '@/utils/request'

const base = '/dkmall/catalog-maintenance'

export const listComments = params => request({ url: `${base}/comments`, method: 'get', params })
export const listReplies = id => request({ url: `${base}/comments/${id}/replies`, method: 'get' })
export const replyComment = (id, data) => request({ url: `${base}/comments/${id}/reply`, method: 'post', data })
export const setCommentStatus = (id, status) => request({ url: `${base}/comments/${id}/status/${status}`, method: 'put' })
export const listDesignComments = params => request({ url: `${base}/design-comments`, method: 'get', params })
export const setDesignCommentShow = (id, region, show) => request({ url: `${base}/design-comments/${id}/show`, method: 'put', params: { region, show } })
export const setDesignCommentSort = (id, sort) => request({ url: `${base}/design-comments/${id}/sort`, method: 'put', params: { sort } })